import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MaterialTypesState } from '../reducers/material-types.reducer';
import { MATERIAL_TYPES_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<MaterialTypesState>(MATERIAL_TYPES_FEATURE_KEY);

export const selectMaterialTypes = createSelector(selectState, (state: MaterialTypesState) => state.materialTypes);
export const selectLoaded = createSelector(selectState, (state: MaterialTypesState) => state.loaded);
export const selectMaterials = createSelector(selectState, (state: MaterialTypesState) => state.materials);
export const selectMaterialsLoading = createSelector(selectState, (state: MaterialTypesState) => state.materialsLoading);
